import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/purchase/payments";

//#region state
const state = {
  purchasePayments: [],
  lastFormNumber: null,
  lastVoucherNumber: null,
  purchasePayment: {},
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Purchase Payment", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `PP.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `PP.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastVoucherNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/voucher-number`);
      if (response.status === 200) {
        context.commit("SET_LAST_VOUCHER_NUMBER", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVoucherPayment(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/voucher/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(`${BASE_URL}`);
      if (response.status === 200) {
        context.commit("SET_PURCHASE_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApproval(context) {
    try {
      const response = await api.get(`${BASE_URL}/approval`);
      if (response.status === 200) {
        context.commit("SET_PURCHASE_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApprovalOther(context) {
    try {
      const response = await api.get(`${BASE_URL}/approval/other`);
      if (response.status === 200) {
        context.commit("SET_PURCHASE_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApprovalSubcon(context) {
    try {
      const response = await api.get(`${BASE_URL}/approval/subcon`);
      if (response.status === 200) {
        context.commit("SET_PURCHASE_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async approval(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/approval`, body);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, purchasePaymentId) {
    try {
      const response = await api.get(`${BASE_URL}/${purchasePaymentId}`);
      // if (response.status === 200) {
      //   context.commit("SET_PURCHASE_PAYMENT", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryPayment(context, queryPayment) {
    try {
      const response = await api.post(`${BASE_URL}/query`, queryPayment);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Purchase Payment" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListInvoice(context, vendorId) {
    try {
      const response = await api.get(`${BASE_URL}/invoices/${vendorId}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListInvoiceById(context, purchaseReturnId) {
    try {
      const response = await api.get(`${BASE_URL}/invoices/by/${purchaseReturnId}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAccountNumbers(context, params) {
    try {
      const response = await api.get(`${BASE_URL}/account-numbers/${params.id}`, params);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getChecklist() {
    try {
      const response = await api.get(`${BASE_URL}/checklist`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApproved() {
    try {
      const response = await api.get(`${BASE_URL}/approved`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateChecklist(context, items) {
    try {
      const response = await api.post(`${BASE_URL}/checklist`, items);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateApproved(context, data) {
    try {
      const response = await api.post(`${BASE_URL}/approved`, data.body, {
        params: { pin: data.pin },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDropdownByVendorId(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/vendor/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async checkPaymentByPoIds(context, poIds) {
    try {
      const response = await api.get(`${BASE_URL}/check-po?poIds=${poIds.join(",")}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async mergePurchasePayment(context, body) {
    try {
      const response = await api.post(`${BASE_URL}/merge`, body);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_LAST_VOUCHER_NUMBER(state, payload) {
    state.lastVoucherNumber = payload;
  },
  SET_PURCHASE_PAYMENT(state, payload) {
    state.purchasePayment = payload;
  },
  SET_PURCHASE_PAYMENTS(state, payload) {
    state.purchasePayments = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
